import React from 'react';
// @ts-nocheck
import {Column} from 'react-table'
import {Model} from '@/_metronic/helpers'
import {
  TextCell,
  DateCell,
  ActionsCell,
  IdentityCell,
  CustomHeader
} from '@/components/table/columns'
import {StatusCell, MessagesCell, TypeCell} from './SupportCells'

const df = {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
  second: 'numeric'
} as Intl.DateTimeFormatOptions

const Columns: ReadonlyArray<Column<Model>> = [
  // User data
  {
    Header: (props) => <CustomHeader tableProps={props} title='Name' className='min-w-125px' />,
    id: 'username',
    Cell: ({...props}) =>(
      <IdentityCell
        email={props.data[props.row.index].user.email}
        displayName={props.data[props.row.index].user.username}
        avatar={{
          type: props.data[props.row.index].user.avatar
        }}
        to={`/p2c/customers/${props.data[props.row.index].user._id}/overview`}
      />
    )
  },
  // Ticket date
  {
    Header: (props) => <CustomHeader tableProps={props} title="Date" className='min-w-125px sortable' />,
    id: 'date',
    Cell: ({...props}) => <DateCell date={props.data[props.row.index].date} format={df}/>
  },
  // Ticket type
  {
    Header: (props) => <CustomHeader tableProps={props} title="Type" className='min-w-125px' />,
    id: 'type',
    Cell: ({...props}) => <TypeCell type={props.data[props.row.index].type} />
  },
  // Ticket Status
  {
    Header: (props) => <CustomHeader tableProps={props} title="Status" className='min-w-125px' />,
    id: 'status',
    Cell: ({...props}) => <StatusCell status={props.data[props.row.index].status} />
  },
  // Number of messages
  {
    Header: (props) => <CustomHeader tableProps={props} title='Messages' className='min-w-125px text-end pe-0' />,
    id: 'messages',
    Cell: ({...props}) => <MessagesCell messages={props.data[props.row.index].messages.length} />,
  },
  // Actions
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Actions' className='text-end min-w-100px' />
    ),
    id: 'actions',
    Cell: ({...props}) => (
      <ActionsCell
        itemForUpdate={props.data[props.row.index]}
        actions={[{
          icon: 'exit-right-corner',
          label: 'Details',
          openModal: 'details'
        }]}
      />
    )
  }
]

export {Columns}
